/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';


const BillingPartyBranchDropdown = ({
    field: { name },
    form: { setFieldValue },
    getBillingPartySelected,
    billingPartyId,
    setBillingBranchName,
    billingPartyBranchArray,
    ...props
}) => {

    const [billingParty, setBillingParty] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [billingPartyBranchArrayEdit, setBillingPartyBranchArrayEdit] = useState([])

    useEffect(() => {
        if (billingPartyId) {

            console.log("Biling Party ID in BillingPArtyBranch", billingPartyId)

            let token = localStorage.getItem('isloggedIn')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNumber')
            let btemparray = localStorage.getItem('billingpartbranchIds');


            Axios.get(`${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${response.data.resultSet[0].billingPartyId}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                if (btemparray != "") {

                    let btemp = btemparray.split(",");
                    let btempa = [];
                    for (let index = 0; index < options.length; index++) {
                        for (let indexj = 0; indexj < btemp.length; indexj++) {
                            if (options[index].billingPartyBranchId == +btemp[indexj]) {
                                btempa.push(options[index]);
                            }
                        }
                    }
                    let temp = btempa.map((item, index) => {
                        return {
                            key: item.billingPartyBranchId,
                            value: item.billingPartyBranchId,
                            text: item.billingPartyBranchName,
                            raw: { ...item },
                        };
                    })
                    setBillingPartyBranchArrayEdit(temp);

                } else {
                    setBillingPartyBranchArrayEdit(response.data.resultSet);
                }
            }))
                .catch(error => console.log(error))
        }
    })


    let options = []
    if (billingPartyId) {
        if (billingPartyBranchArrayEdit && billingPartyBranchArrayEdit.length > 0) {
            billingPartyBranchArrayEdit.map((object, index) => {
                let temp = {}
                temp.key = object.billingPartyBranchId
                temp.text = object.billingPartyBranchName
                temp.value = object.billingPartyBranchId
                temp.raw = object
                return options[index] = temp
            })
        }
    } else {
        if (billingPartyBranchArray && billingPartyBranchArray.length > 0) {
            billingPartyBranchArray.map((object, index) => {
                let temp = {}
                temp.key = object.billingPartyBranchId
                temp.text = object.billingPartyBranchName
                temp.value = object.billingPartyBranchId
                temp.raw = object
                return options[index] = temp
            })
        }
    }

    return (
        <>
            <Dropdown
                selection
                search
                onChange={(value, data) => {
                    setFieldValue(name, data.value);
                    data.options.map((item, o) => {
                        if (item?.raw?.billingPartyBranchId == data.value) {
                            setBillingBranchName && setBillingBranchName(item?.raw?.billingPartyBranchName, data.value)
                        }
                    });
                }}
                options={options}
                clearable
                loading={isLoading}
                {...props}
                fluid
            />
            {console.log("Checking what array comes", billingPartyBranchArray)}
        </>

    )
}

export default BillingPartyBranchDropdown